var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-legend"},[(_vm.title)?_c('span',{staticClass:"calendar-legend__title"},[_vm._v(_vm._s(_vm.title)+" :")]):_vm._e(),_c('span',{staticClass:"calendar-legend__badges"},_vm._l((_vm.items),function(item){return _c('ElementBadge',{key:item.guid,attrs:{"text":item.label,"colorHex":item.color,"showText":true}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }